<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row>


				<v-flex xs12 sm6 offset-sm3 v-show="!dialogEditor">
					<v-card>
						<template v-if="isLoading">
							<div class="text-xs-center pa-5">
								<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
								<div class="caption mt-4">Kullanıcı listesi yükleniyor</div>
							</div>
						</template>
						<template v-if="!isLoading">
							<v-toolbar color="indigo" dark>
								<v-toolbar-title>Kullanıcılar</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon @click="openEditor(false)">
									<v-icon>add_circle</v-icon>
								</v-btn>
							</v-toolbar>


							<v-list two-line>
								<template v-for="(user, userIndex) in users">
									<v-list-tile :key="userIndex" avatar @click="openEditor(user)">
										<v-list-tile-avatar>
											<img :src="user.logo">
										</v-list-tile-avatar>
										<v-list-tile-content>
											<v-list-tile-title> {{user.firstname}} {{user.lastname}}
											</v-list-tile-title>
											<v-list-tile-sub-title>{{user.username}}</v-list-tile-sub-title>
										</v-list-tile-content>
									</v-list-tile>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>


				<div class="Profile" v-show="dialogEditor">
					<div class="profileTop">
						<div class="avatar">
							<img :src="editUser.logo" alt="" title="Gravatar dan alınıyor">
						</div>
						<div class="fullname">
							{{editUser.firstname}} {{editUser.lastname}} &nbsp;
						</div>
						<div class="email">
							{{editUser.email}} &nbsp;
						</div>
						<div class="email">
							{{editUser.token}}
						</div>
						<div class="btncLeft">
							<v-btn fab small color="dark" outline @click="dialogEditor = false">
								<v-icon dark>chevron_left</v-icon>
							</v-btn>
						</div>
						<div class="btncRight">
							<!-- <v-btn fab   small color="dark" outline> 
								<v-icon dark>close</v-icon>
							</v-btn> -->
						</div>
					</div>

					<div class="profileForm">
						<div class="formLine">
							<v-text-field v-model="editUser.username" label="Kullanıcı Adı">
							</v-text-field>
						</div>
						<div class="formLine">
							<v-text-field v-model="editUser.password"
								:append-icon="showPassword ? 'visibility' : 'visibility_off'"
								:type="showPassword ? 'text' : 'password'" label="Şifreyi değiştir"
								hint="Boş bırakılırsa değişiklik yapılmaz" @click:append="showPassword = !showPassword">
							</v-text-field>
						</div>
						<div class="formLineHr"> </div>
						<div class="formLine">
							<v-select v-model="editUser.group_id" hide-details :items="groups" item-text="group_name"
								item-value="id" label="Kullanıcı Yetki Grubu"></v-select>
						</div>
						<div class="formLineHr"> </div>
						<div class="formLine">
							<v-text-field v-model="editUser.firstname" label="Ad" placeholder="Örn: Melih">
							</v-text-field>
						</div>
						<div class="formLine">
							<v-text-field v-model="editUser.lastname" label="Soyad" placeholder="Örn: ÖRNEKBAŞ"
								required>
							</v-text-field>
						</div>
						<div class="formLine">
							<v-text-field v-model="editUser.email" label="E-Mail" placeholder="Örn: melih@ajans360.com"
								required>
							</v-text-field>
						</div>
						<div class="formLine">
							<v-text-field v-model="editUser.birthday" label="Doğum Tarihi (dd.mm.yyyy)"
								placeholder="Örn: 01.01.1994" required>
							</v-text-field>
						</div>
						<div class="formLine ">
							<div class="text-xs-center formLineActions">
								<v-btn round outline color="error" dark @click="dialogAskRemove = true" v-show="editUser.id">SİL</v-btn>
								<v-btn round outline color="indigo" dark v-if="editUser.id" @click="saveUser()">KAYDET</v-btn>
								<v-btn round outline color="indigo" dark v-if="!editUser.id" @click="saveUser()">EKLE</v-btn>
							</div>
						</div>
					</div>

				</div>



				<v-dialog v-model="dialogAskRemove" max-width="400">
					<v-card>
						<v-card-title class="headline">Bu kullanıcıyı silmek istediğinzie emin misiniz</v-card-title> 
						<v-card-actions> 
							<v-btn color="success darken-1" flat="flat" @click="dialogAskRemove = false">
								VAZGEÇ
							</v-btn> 
							<v-spacer></v-spacer>
							<v-btn color="error darken-1" flat="flat" @click="removeUser()">
								EMİNİM
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>



			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	export default {
		name: "UsersGroupsIndex",
		components: {},
		data() {
			return {
				isLoading: true,
				dialogEditor: false,
				authlist: [],
				groups: [],
				editUser: {},
				showPassword: false,
				dialogAskRemove : false
			}
		},
		mounted() {
			this.loadGroups();
		},
		methods: {
			loadGroups() {
				this.isLoading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/users/groups", {
					params: {}
				}).then(response => {
					this.groups = response.body;
					this.loadUsers();
				})
			},
			loadUsers() {
				this.isLoading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/users/users", {
					params: {}
				}).then(response => {
					this.users = response.body;
					this.isLoading = false;
				})
			},
			openEditor(item) {
				if (item) {
					this.editUser = JSON.parse(JSON.stringify(item));
				} else {
					this.editUser = {
						id: "",
						group_id: 0,
						username: "",
						password: "",
						email: "",
						firstname: "",
						lastname: "",
						birthday: "",
					}
				}
				this.dialogEditor = true;
				this.showPassword = false;
			},
			saveUser() {
				this.dialogEditor = false;
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/users/users/save", this.editUser, {
					params: {}
				}).then(response => {
					this.loadUsers();
				})
			},
			removeUser() {
				this.dialogAskRemove = false;
				this.dialogEditor = false;
				this.isLoading = true; 
				this.$http.post(process.env.VUE_APP_API_URL + "/users/users/remove", this.editUser, {
					params: {}
				}).then(response => {
					this.loadUsers();
				})
			},
		},
		computed: {

		}
	}
</script>



<style lang="less">
	.Profile {
		width: 400px;
		max-width: calc(~"100% - 20px");
		margin: 0px auto;
		min-height: 300px;
		background-color: #fff;
		box-shadow: 0 0 5px rgb(141, 141, 141);

		.profileTop {
			border-bottom: 2px solid #ccc;
			padding: 10px 0px;
			position: relative;

			.avatar {
				text-align: center;

				img {
					width: 100px;
					height: 100px;
					object-fit: cover;
					border-radius: 50%;
					border: 2px solid rgb(158, 158, 158);
				}
			}

			.fullname {
				text-align: center;
				font-size: 30px;
				font-weight: 300;
			}

			.email {
				text-align: center;
				font-size: 12px;
				color: rgb(100, 100, 100);
			}

			.btncLeft {
				position: absolute;
				left: 0px;
				top: 0px;
			}

			.btncRight {
				position: absolute;
				right: 0px;
				top: 0px;
			}
		}

		.profileForm {
			padding: 15px;

			.formLineHr {
				border-bottom: 2px solid #ccc;
				margin: 10px -15px 20px -15px;
			}

			.formLineActions {
				min-height: 50px;

				.v-btn:first-child {
					float: left;
				}

				.v-btn:last-child {
					float: right;
				}
			}
		}
	}
</style>